import _typeof from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useState } from "react";
import AwesomeIcon from "../../AwesomeIcon";
import { faChevronDown, faChevronUp, faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { format, parseISO } from "date-fns";
import { useTranslation } from "react-i18next";
import { parseReportText } from "../../../utils/reportParser";
var ReportDetails = function ReportDetails(_ref) {
  var _submissionDetail$rep, _submissionDetail$met, _submissionDetail$rep2, _submissionDetail$rep3;
  var submissionDetail = _ref.submissionDetail;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    isMetadataExpanded = _useState[0],
    setIsMetadataExpanded = _useState[1];
  var reportText = (submissionDetail === null || submissionDetail === void 0 || (_submissionDetail$rep = submissionDetail.report) === null || _submissionDetail$rep === void 0 ? void 0 : _submissionDetail$rep.report_text) || (submissionDetail === null || submissionDetail === void 0 || (_submissionDetail$met = submissionDetail.metadata) === null || _submissionDetail$met === void 0 ? void 0 : _submissionDetail$met.report_text) || "No report data available";
  var updatedAt = submissionDetail === null || submissionDetail === void 0 || (_submissionDetail$rep2 = submissionDetail.report) === null || _submissionDetail$rep2 === void 0 ? void 0 : _submissionDetail$rep2.updated_at;
  var examDate = updatedAt ? format(parseISO(updatedAt), "MM/dd/yyyy, h:mma") : null;
  var metadataEntries = Object.entries((submissionDetail === null || submissionDetail === void 0 || (_submissionDetail$rep3 = submissionDetail.report) === null || _submissionDetail$rep3 === void 0 ? void 0 : _submissionDetail$rep3.metadata) || {});

  // Parse report text into structured sections
  var reportSections = parseReportText(reportText);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full bg-[#E8E9EA] dark:bg-[#141F2A]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center p-4 bg-gray-200/50 dark:bg-gray-800 border-b border-[#BBBFC2] dark:border-[#646B72]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col text-left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-base font-semibold text-[#0C1723] capitalize dark:text-[#F6F7F7]"
  }, t("label.acr.report_heading")), examDate && /*#__PURE__*/React.createElement("span", {
    className: "text-md text-gray-600 dark:text-gray-400"
  }, examDate)))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col min-h-0 p-4 gap-3"
  }, metadataEntries.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "rounded-lg border border-gray-300 dark:border-gray-700 overflow-hidden flex-shrink-0"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setIsMetadataExpanded(!isMetadataExpanded);
    },
    className: "flex items-center justify-between w-full px-3 py-2.5 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors cursor-pointer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircleInfo,
    size: "1x",
    className: "text-teal-600 dark:text-teal-400"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-base font-semibold"
  }, t("label.acr.report_metadata")), /*#__PURE__*/React.createElement("span", {
    className: "text-sm text-gray-500 dark:text-gray-500"
  }, "(", metadataEntries.length, ")")), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isMetadataExpanded ? faChevronUp : faChevronDown,
    size: "1x",
    className: "text-gray-500 dark:text-gray-500"
  })), isMetadataExpanded && /*#__PURE__*/React.createElement("div", {
    className: "border-t border-gray-300 dark:border-gray-700 max-h-48 overflow-y-auto scrollbar-light dark:scrollbar"
  }, metadataEntries.map(function (_ref2, index) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: "flex items-baseline justify-between px-3 py-2 border-b border-gray-300 dark:border-gray-700 ".concat(index % 2 === 0 ? "bg-gray-100 dark:bg-gray-800/50" : "")
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-sm font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide shrink-0 mr-4"
    }, key), /*#__PURE__*/React.createElement("span", {
      className: "text-sm text-gray-800 dark:text-gray-200 text-right break-all"
    }, _typeof(value) === "object" ? JSON.stringify(value) : String(value !== null && value !== void 0 ? value : "—")));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-h-0 overflow-y-auto scrollbar-light dark:scrollbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-4 p-4"
  }, reportSections.length > 0 ? reportSections.map(function (section, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "pb-4 last:border-b-0"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-md text-left font-semibold text-[#0C1723] uppercase dark:text-[#F6F7F7] mb-2 tracking-wider"
    }, section.heading), /*#__PURE__*/React.createElement("p", {
      className: "text-[14px] text-[#565D66] dark:text-[#A8ACB0] whitespace-pre-wrap text-left leading-relaxed"
    }, section.content));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-[14px] text-gray-700 dark:text-gray-300 whitespace-pre-wrap text-left leading-relaxed"
  }, reportText)))));
};
export default ReportDetails;